export default class Api {

    static overwriteOrigin = null;

    static get origin() {

        if (Api.overwriteOrigin)
            return Api.overwriteOrigin;

        return (env?.HTTP_ORIGIN != undefined)
            ? env.HTTP_ORIGIN
            : window.location.origin.replace(/\:\d+$/, '');
    }

    static setOrigin(value) {

        Api.overwriteOrigin = value;
    }

    static fetch(url, postArgs = null, headers = null) {

        const params = {};

        if (postArgs) {

            if (typeof(postArgs) != 'object')
                throw new Error('Invalid postArgs type');

            params['method'] = 'POST';
            params['body'] = JSON.stringify(postArgs);
        }

        if (headers)
            params['headers'] = headers;
        
        return new Promise((resolve, reject) => {

            fetch(url, params)
                .then((response) => response.json())
                .then((response) => {

                    response.success
                        ? resolve(response.context != undefined ? response.context : response)
                        : reject({
                            code: response?.statusCode ?? 500,
                            message: response?.message,
                        });
                })
                .catch((e) => reject({ code: 500, message: e }));
        });
    }
}